// extracted by mini-css-extract-plugin
module.exports = {"fieldItemCard":"fieldItem_fieldItemCard__28h64","dragging":"fieldItem_dragging__1jeSA","dropHere":"fieldItem_dropHere__25Syr"};